module.exports = __webpack_public_path__ + "assets/favicon-grey-24.png?1f754dc324a67458067ce151de73300d";